module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "copy-t1"
  }, [_vm._v("What’s Wrong with My Child?")]), _vm._v(" "), _c('p', {
    staticClass: "copy-t2"
  }, [_vm._v("One Mother’s Desperate Quest to Uncover What Was Really Wrong with Her Family ... and The Disturbing Facts She Revealed that Could Help Save Yours")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("© 2022 Elizabeth Harris")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("All rights reserved. No portion of this book may be reproduced, stored in a retrieval system, or transmitted in any form or by any means—electronic, mechanical, photocopy, recording, scanning, or other—except for brief quotations in critical reviews or articles, without the prior written permission of the publisher.")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_vm._v("Published in New York, New York, by Morgan James Publishing. Morgan James is a trademark of Morgan James, LLC. "), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.MorganJamesPublishing.com")])]), _vm._v(" "), _c('table', [_c('colgroup', [_c('col', {
    attrs: {
      "width": "40%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "60%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "imageb"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/bogofm.png"
    }
  })])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "copy"
  }, [_vm._v("ISBN 9781631954979 paperback")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("ISBN 9781631954986 eBook")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Library of Congress Control Number: 2021930808")]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("Cover Design by:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Christopher Kirk")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_c('a', {
    attrs: {
      "href": "http://www.GFSstudio.com",
      "target": "_blank"
    }
  }, [_vm._v("www.GFSstudio.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copy"
  }, [_c('b', [_vm._v("Interior Design by:")])]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_vm._v("Chris Treccani")]), _vm._v(" "), _c('p', {
    staticClass: "copyn"
  }, [_c('a', {
    attrs: {
      "href": "http://www.3dogcreative.net",
      "target": "_blank"
    }
  }, [_vm._v("www.3dogcreative.net")])])])])])]), _vm._v(" "), _c('p', {
    staticClass: "imagelogo"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/logo.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Morgan James is a proud partner of Habitat for Humanity Peninsula and Greater Williamsburg. Partners in building since 2006.")]), _vm._v(" "), _c('p', {
    staticClass: "copyc"
  }, [_vm._v("Get involved today! Visit"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.MorganJamesPublishing.com/giving-back",
      "target": "_blank"
    }
  }, [_vm._v("MorganJamesPublishing.com/giving-back")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d5630092","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/copy.vue
// module id = 69
// module chunks = 0